"use client";

import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../../defaultTheme";
export const StyledTableBody = styled(({
  children,
  className,
  dataTest
}) => /*#__PURE__*/React.createElement("tbody", {
  className: className,
  "data-test": dataTest
}, children)).withConfig({
  displayName: "TableBody__StyledTableBody",
  componentId: "sc-1skzchf-0"
})(["width:100%;white-space:nowrap;border-bottom:1px solid ", ";"], ({
  theme
}) => theme.orbit.borderColorTable);
StyledTableBody.defaultProps = {
  theme: defaultTheme
};
const TableBody = ({
  children,
  dataTest
}) => /*#__PURE__*/React.createElement(StyledTableBody, {
  dataTest: dataTest
}, children);
export default TableBody;